import React, { useEffect, useRef, useState } from 'react'
import Home from '../Components/Home'
import GlobalReach from '../Components/GlobalReach'
import ProductOffering from '../Components/ProductOffering'
import Testimonial from '../Components/Testimonial'
import Assembly from '../Components/Assembly'
import Team from '../Components/Team'
import JoinTeam from '../Components/JoinTeam'
import Gallery from '../Components/Gallery'
import Contact from '../Components/Contact'
import LogoSwiper from '../Components/LogoSwiper'

const DureWebsite = () => {

  const globalReachRef = useRef(null);
  const [showScrollMouse, setShowScrollMouse] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (!globalReachRef.current) return;

      const bottomOfGlobalReach =
        globalReachRef.current.offsetTop + globalReachRef.current.offsetHeight;

      if (window.scrollY > bottomOfGlobalReach - 50) {
        setShowScrollMouse(false); // fade OUT
      } else {
        setShowScrollMouse(true); // fade IN when above
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <Home showScrollMouse={showScrollMouse} />
      <div ref={globalReachRef}>
        <GlobalReach />
      </div>
      <LogoSwiper />
      <ProductOffering />
      <Testimonial />
      <Assembly />
      <Team />
      <JoinTeam />
      <Gallery />
      <Contact />
    </div>
  );
}

export default DureWebsite